import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon } from '@icons';
import classNames from 'classnames';
import React, { useCallback, useMemo, useRef, } from 'react';
import { useFirstRender } from '../common/effects/useFirstRender';
import useFocusNew from '../common/effects/useFocusNew';
import { useKey } from '../common/effects/useKey';
import { isDark } from '../common/utils';
import styles from './tags.module.scss';
const TagItem = React.memo(({ id, name, disabled, handleRemove, readonly, tagWidth, tagStyle, size, markedForRemoval, focusable, accent, }) => {
    const ref = useRef(null);
    const isFirstRender = useFirstRender();
    const handleClick = useCallback(() => {
        id && handleRemove(id);
    }, []);
    useKey(ref, handleClick);
    const editable = useMemo(() => !disabled && !readonly, []);
    const isDarkMode = useMemo(() => isDark(), []);
    const tagItemClass = useMemo(() => classNames(styles.tag, 'rc-tag', {
        [styles.disabled]: disabled,
        [styles.marked_for_removal]: markedForRemoval && !isFirstRender.current,
        [styles[`style_${tagStyle}`]]: true,
        [styles[`${size}`]]: true,
        [styles.readonly]: readonly,
        [styles[`accent_${accent}`]]: true,
        [styles.dark]: isDarkMode,
    }), [markedForRemoval]);
    const tagIconClass = useMemo(() => classNames(styles.icon, {
        [styles[`icon_${tagStyle}`]]: true,
        [styles.icon_editable]: editable,
    }), [editable]);
    const tagName = useMemo(() => classNames(styles.name, {}), []);
    const style = useMemo(() => ({
        '--width': `${tagWidth}px`,
    }), []);
    useFocusNew(focusable ? ref : null, focusable ? handleClick : null);
    return (_jsxs("li", { className: tagItemClass, style: style, children: [_jsx("span", { className: tagName, title: name, children: name }), _jsx("span", { className: tagIconClass, onClick: handleClick, ref: ref, role: "button", "aria-label": "delete tag", tabIndex: focusable ? 0 : -1, children: _jsx(CloseIcon, {}) })] }, id));
}, (prevProps, nextProps) => {
    return (prevProps.disabled === nextProps.disabled &&
        prevProps.markedForRemoval === nextProps.markedForRemoval);
});
TagItem.displayName = 'TagItem';
export { TagItem };
